import React, { useEffect } from "react";
import "styles/Login.scss";
import { Form, Input, Button, message } from "antd";
import { ILoginParams } from "types/login";
import { login } from "api/auth";
import { logout, setToken, setUser } from "api/axios";
import { useNavigate } from "react-router-dom";
import useFormInstance from "antd/es/form/hooks/useFormInstance";

const Login: React.FC = () => {
  const form = useFormInstance();
  const navigate = useNavigate();

  const onFinish = async (values: ILoginParams) => {
    try {
      const data = await login(values);
      if (data.success) {
        setToken(data.data.access_token);
        setUser(data.data.user);
        navigate("/");
      } else {
        message.error("エラーが発生しました。");
      }
    } catch (error) {
      if (error?.response?.status === 400) {
        message.error("IDまたはパスワードが不正です。");
      } else if (error?.response?.status === 401) {
        message.error("IDまたはパスワードが不正です。");
      } else {
        message.error("エラーが発生しました。");
      }
    }
  };

  useEffect(() => {
    logout();
  }, []);

  return (
    <div className="login-container">
      <h2>ログイン</h2>
      <Form
        name="normal_login"
        className="login-form"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name="id"
          className="form-item"
          rules={[{ required: true, message: "IDを入力してください" }]}
        >
          <Input placeholder="ID *" className="input" />
        </Form.Item>
        <Form.Item
          name="password"
          className="form-item"
          rules={[{ required: true, message: "パスワードを入力してください" }]}
        >
          <Input.Password className="input" placeholder="パスワード *" />
        </Form.Item>
        <Form.Item className="form-item">
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            ログイン
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Login;
